import React from 'react';
import {Radar, RadarChart, PolarGrid, 
        PolarAngleAxis, ResponsiveContainer, Tooltip
} from 'recharts';



export default function RadarChartReport({ data }){

    return (<div className="card shadow printable-unit">
                <h3 className="card-label">Character Type Strength Profile</h3>
                <div className="chart-wrapper-md">
                <ResponsiveContainer width="100%" height="100%">
                    <RadarChart data={data}>
                    <PolarGrid stroke="#cbd5e1" />
                    <PolarAngleAxis dataKey="subject" tick={{ fontSize: 11, fill: '#64748b' }} />
                    <Radar
                        name="Score"
                        dataKey="A"
                        stroke="#6366f1"
                        fill="#6366f1"
                        fillOpacity={0.5}
                    />
                    <Tooltip />
                    </RadarChart>
                </ResponsiveContainer>
                </div>

                <div className='container-flex-column-bgwhite'>
                    <h1>References:</h1>
                    <ul className='flex-column-items-left'>
                        <li className='font-s12'><span>A_ Innovative Architect </span></li>
                        <li className='font-s12'><span>B_ Magnetic Connector</span></li>
                        <li className='font-s12'><span>C_ Humanitarian Negotiator</span></li>
                        <li className='font-s12'><span>D_ Visionary Leader</span></li>
                        <li className='font-s12'><span>E_ Achievement Accelerator</span></li>
                    </ul>
                </div>
            </div>
            )
};